import DistrictManage from './DistrictManage';

export default DistrictManage;
